import React from "react";

import withSessionHandling from "@/context/auth/withSessionHandling";
import SubscriptionScreen from "@/screens/Settings/AccountManagement/SubscriptionScreen";

function Page(): React.JSX.Element {
  return <SubscriptionScreen />;
}

export default withSessionHandling(Page);
